import { useTranslation } from 'react-i18next';
import { SectionCard } from '@/components/ui';
import { hasFailedProbe } from './approvalGate';
import { ConnectionCheckResult } from './ConnectionCheckResult';
import type { AppApprovalVM } from './useAppApproval';
import detail from './AppDetail.module.css';

/**
 * EAA-1709: the latest pre-approval connection check, with one line saying what
 * it means for "Duyệt". Renders nothing until a check has run in this session.
 */
export function AppApprovalCheckPanel({
    approval,
    className,
}: {
    approval: AppApprovalVM;
    className?: string;
}) {
    const { t } = useTranslation();
    const report = approval.report;
    if (!report) return null;

    let hintKey = 'console.appDetail.approval.hintReady';
    if (approval.stale) hintKey = 'console.appDetail.approval.hintStale';
    else if (hasFailedProbe(report)) hintKey = 'console.appDetail.approval.hintFailed';

    return (
        <SectionCard className={className} title={t('console.appDetail.approval.panelTitle')}>
            <p className={detail.hint} data-testid="app-approval-hint">
                {t(hintKey)}
            </p>
            <ConnectionCheckResult report={report} />
        </SectionCard>
    );
}

export default AppApprovalCheckPanel;
